export default __webpack_public_path__ + "static/assets/med_pill_square_flat_L0_solid_x_01_f.a4d51ab5.png";